import { Col, Row } from "react-bootstrap";
import BrandLogo from "../../components/BrandLogo/BrandLogo";
import create_profile_icon from "../../assets/images/create_profile_icon.png";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import * as apicall from "../../components/Apicall";
import Loader from "../../components/Loader/Loader";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const ProfileSetup = () => {
  const [initialValues, setInitialValues] = useState({
    name: "",
    email: "",
    phone: "",
  });
const location = useLocation();

  const otpRes = location.state?.otpRes;
  const [searchParams] = useSearchParams();
  let navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [isEmail, setIsEmail] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
// Inside your ProfileSetup component
const [fullNumber, setFullNumber] = useState(initialValues.phone || "");
const [phoneNumber, setPhoneNumber] = useState(""); // phone without country code
const [countryCode, setCountryCode] = useState("");
const [errorMessage, setErrorMessage] = useState("");
const formikRef = useRef();
// Function to handle phone input changes
const countryRules = {
  in: {
    length: 10,
    regex: /^[6-9]\d{9}$/, // starts with 6-9
  },
  ae: {
    length: 9,
    regex: /^(50|52|54|55|56|58)\d{7}$/, // valid UAE prefixes
  },
};

const numberOnChange = (value, country) => {
  const rule = countryRules[country.countryCode] || {
    length: 10,
    regex: /^\d+$/,
  };

  let number = value
    .slice(country.dialCode.length)
    .replace(/\D/g, "");

  if (number.length > rule.length) {
    number = number.slice(0, rule.length);
  }

  const full = country.dialCode + number;

  setFullNumber(full);

  formikRef.current?.setFieldValue("phone", full);

  if (number.length === rule.length && rule.regex.test(number)) {
    setErrorMessage("");
    setCountryCode(country.dialCode);
    setPhoneNumber(number);
  } else {
    setErrorMessage(
      `Please enter a valid ${country.name} mobile number (minimum ${rule.length} digits)`
    );
  }
};
useEffect(() => {
  setFullNumber(initialValues.phone || "");
}, [initialValues.phone]);
  useEffect(() => {
    const phoneNumber = searchParams.get("phone_number");
    const email = searchParams.get("email");

    if (!phoneNumber) {
      setIsEmail(true);
    } else {
      setIsEmail(false);
    }
    setInitialValues({
      name: "",
      email: email || "",
      password: "",
      phone: phoneNumber || "",
    });
  }, [searchParams]);

  const validationSchema = Yup.object({
    name: Yup.string().min(2, "Too Short!").required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    phone: Yup.string().required("Mobile Number is required"),
    password: isEmail
      ? Yup.string()
          .min(6, "Password minimum at least 6 characters")
          .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/,
            "Password must contain at least one uppercase letter, one lowercase letter and one number"
          )
          .required("Password is required")
      : Yup.string(),
  });

  // console.log("validationSchema----", validationSchema);

  // const sumbitProfileInfo = async (values) => {
  //   try {
  //     // console.log("sumbitProfileInfo------", values);
  //     const res = await apicall.post(values, "ezp_profile_register");
  //     // console.log("res------", res);
  //     // navigate("/dashboard");
  //     navigate("/setup");
  //   } catch (e) {
  //     console.log("err--sumbitProfileInfo---", e);
  //   }
  // };

const sumbitProfileInfo = async (values) => {
  try {
    // const formattedPhone = `${countryCode}${phoneNumber}`;
    // const formattedPhone = !isEmail
    //   ? values.phone
    //   : `${countryCode}${phoneNumber}`;
// console.log("formattedPhone--", formattedPhone, values.phone, initialValues.phone,formattedPhone)
    // if (!formattedPhone) {
    //   setErrorMessage("Phone number is required");
    //   return;
    // }
    const formattedPhone = values.phone;

    if (!values.phone) {
  formikRef.current.setFieldTouched("phone", true);
  return;
}
    const payload = {
      ...values,
      phone: formattedPhone,
    };

    const res = await apicall.post(payload, "ezp_profile_register");
    //  backend handles validation
    if (!res?.success) {
      setErrorMessage(res.message);
      return;
    }
  let isBasicSetupDone = await checkUserBasicSetup();

        if (!isBasicSetupDone) {
           navigate("/industry");
        }else{
              navigate("/setup");

        }

  } catch (e) {
  console.log("Submit error:", e);

  const backendMessage =
    e?.response?.data?.message ||  // axios
    e?.data?.message ||            // custom wrapper
    e?.message;

  setErrorMessage(
    backendMessage || "Something went wrong. Please try again."
  );
}
};
  const checkUserBasicSetup = async () => {
  try {
    let res = await apicall.get(
      `getUserOnboardingStatus?user_id=${otpRes.user_id}`
    );


    let ans = {
      industry: !!res?.data?.[0]?.industry,
      services: !!res?.data?.[0]?.services_location,
    };

    return Object.values(ans).every(Boolean);

  } catch (e) {
    return false;
  }
};
  // console.log("phone_number---------", phone);

  return (
    <div>
      <header>
        <nav className="p-2 background-color-white">
          <BrandLogo height={40} />
        </nav>
      </header>
      <Row className="profile_bg_color">
        <Col md={8} className="flex_center">
          <div className="left_row">
            <h1 className="title_head">
              Join Us and Unlock Endless Possibilities!
            </h1>
            <h6 className="title_sub_head">
              Lorem ipsum dolor sit amet consectetur. In in vel eget
              pellentesque ultrices ipsum. Diam tempor mauris viverra metus
              gravida lacinia enim sodales. Fusce proin ut fringilla aliquam
              cras. Rutrum tincidunt scelerisque purus quam etiam ullamcorper
              placerat pharetra.
            </h6>
          </div>
        </Col>
        <Col md={4} className="background-color-red">
          <div className="register_form">
            <div>
              <img
                src={create_profile_icon}
                alt={"create_profile_icon"}
                style={{ width: "30px", height: "auto" }}
              />
              <h1 className="title_bold">Register for free</h1>
            </div>

            <Formik
             innerRef={formikRef}
              enableReinitialize={true}
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values, { resetForm }) => {
                // alert("Form Submitted!");
                sumbitProfileInfo(values);
                // resetForm();
              }}
            >
              {() => (
                <Form>
                  <div className="mb-2">
                    <div className="register_label">Name</div>
                    <Field type="text" name="name" />
                    <ErrorMessage
                      name="name"
                      component="div"
                      style={{ color: "red" }}
                    />
                  </div>

                  {/* Email */}
                  <div className="mb-2">
                    <div className="register_label">Email</div>
                    <Field type="email" name="email" readOnly={isEmail} />
                    <ErrorMessage
                      name="email"
                      component="div"
                      style={{ color: "red" }}
                    />
                  </div>

                  {isEmail && (
                    <div className="mb-2">
                      <div className="register_label">Password</div>

                      <Field name="password">
                        {({ field, form }) => {
                          const realPassword = field.value || "";

                          return (
                            <div
                              style={{ position: "relative", width: "100%" }}
                            >
                              <input
                                type={showPassword ? "text" : "password"}
                                value={realPassword}
                                autoComplete="new-password"
                                onChange={(e) => form.setFieldValue("password", e.target.value)}
                                style={{ width: "100%", paddingRight: "40px" }}
                              />

                              <span
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                  position: "absolute",
                                  right: "12px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                }}
                              >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                              </span>
                            </div>
                          );
                        }}
                      </Field>

                      <ErrorMessage
                        name="password"
                        component="div"
                        style={{ color: "red" }}
                      />
                    </div>
                  )}

                  {/* Phone */}
                  <div className="mb-2">
                    <div className="register_label">Phone</div>

  <PhoneInput
  value={formikRef.current?.values?.phone || fullNumber}
    onlyCountries={["in", "ae"]}
    country={"in"}
    // value={fullNumber}
   onChange={(value, country, formattedValue) =>
                                  numberOnChange(
                                    value,
                                    country,
                                    formattedValue
                                  )
                                }
    inputStyle={{ width: "100%" }}
    disabled={!isEmail}
     masks={{
    ae: "... ... ...", //  strictly 9 digits
    in: "..... .....", //  10 digits
  }}
     // editable only if registered via email
  />

                    <ErrorMessage
  name="phone"
  component="div"
  style={{ color: "red" }}
/>
 {errorMessage && (
  <div style={{ color: "red" }}>{errorMessage}</div>
)}
                  </div>

                  <button
                    type="submit"
                    className="btn-danger w-100 border-radius-20 btn-custom-danger border-none p-2 mt-3"
                  >
                    {loader ? (
                      <Loader style={{ width: 40, height: 20 }} />
                    ) : (
                      "Register"
                    )}
                  </button>
                  <div>
                    <p className="text-center mt-3">
                      Already have an account?{" "}
                      <a href="/login" className="text-danger">
                        Login
                      </a>
                    </p>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ProfileSetup;
